import api, { setAccessToken, getAccessToken } from './axios';
import { AuthResponse, LoginRequest, RefreshTokenResponse, User } from '../types';

export class AuthService {
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    console.log('🚀 REAL API LOGIN - Auth service login called with:', credentials);
    
    try {
      const response = await api.post<AuthResponse>('/auth/login', credentials);
      console.log('🎯 REAL API LOGIN - Full response:', response);
      console.log('📦 REAL API LOGIN - Response data:', response.data);
      console.log('🔍 REAL API LOGIN - Response status:', response.status);
      
      // Проверяем структуру ответа
      if (!response.data) {
        throw new Error('No data in response');
      }
      
      // Store tokens (API returns accessToken, not access_token)
      if (response.data.accessToken) {
        setAccessToken(response.data.accessToken);
        console.log('✅ REAL API LOGIN - Token stored successfully');
      } else {
        console.error('❌ REAL API LOGIN - No accessToken in response');
        throw new Error('No accessToken in response');
      }
      
      // Store user
      if (response.data.user) {
        this.setCurrentUser(response.data.user);
        console.log('✅ REAL API LOGIN - User stored successfully:', response.data.user);
      } else {
        console.error('❌ REAL API LOGIN - No user in response');
        throw new Error('No user in response');
      }
      
      console.log('🎉 REAL API LOGIN - Login completed successfully');
      return response.data;
      
    } catch (error) {
      console.error('💥 REAL API LOGIN - Error:', error);
      throw error;
    }
  }

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Even if logout fails on server, clear local state
      console.warn('Logout request failed:', error);
    } finally {
      // Clear all local state
      setAccessToken(null);
      localStorage.removeItem('user');
    }
  }

  async refresh(): Promise<RefreshTokenResponse> {
    const response = await api.post<RefreshTokenResponse>('/auth/refresh');
    const { accessToken } = response.data;
    
    setAccessToken(accessToken);
    
    return response.data;
  }

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch (error) {
      console.error('Failed to parse user data:', error);
      localStorage.removeItem('user');
      return null;
    }
  }

  setCurrentUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  isAuthenticated(): boolean {
    const user = this.getCurrentUser();
    const token = getAccessToken();
    return !!(user && token);
  }

  hasRole(requiredRoles: string[]): boolean {
    const user = this.getCurrentUser();
    if (!user) return false;
    
    return requiredRoles.includes(user.role);
  }

  canAccess(requiredRoles?: string[]): boolean {
    if (!this.isAuthenticated()) return false;
    if (!requiredRoles || requiredRoles.length === 0) return true;
    
    return this.hasRole(requiredRoles);
  }
}

export const authService = new AuthService();
